const setProp = (prop, value) => {
  document.documentElement.style.setProperty(prop, value)
}
const activateFontFace = (face, property, value) => {
  document.fonts.add(face)
  face.load()
  face.loaded
    .then((fontFace) => console.log('Loaded font ', fontFace.family))
    .catch(console.error)
  setProp(property, value)
}

const fontdir = '//resources.experience.jaguarlandrover.com/landrover/fonts'

const FontAvenirRoman = new FontFace(
  'Avenir Roman',
  `url(${fontdir}/Avenir_Roman.woff2)`,
  {
    style: 'normal',
    weight: '400',
  }
)

const FontJaguarBold = new FontFace(
  'Jaguar Bold',
  `url(${fontdir}/Jaguar-Bold.woff)`,
  {
    style: 'normal',
    weight: '700',
  }
)

const FontLandroverBold = new FontFace(
  'Land Rover Bold',
  `url(${fontdir}/LandRoverWeb-Bold.woff2)`,
  {
    style: 'normal',
    weight: '700',
  }
)

const FontProximaNova = new FontFace(
  'Proxima Nova Regular',
  `url(${fontdir}/ProximaNova-Regular.woff2)`,
  {
    style: 'normal',
    weight: '400',
  }
)

const FontProximaNovaBold = new FontFace(
  'Proxima Nova Bold',
  `url(${fontdir}/ProximaNova-Bold.woff2)`,
  {
    style: 'normal',
    weight: '400',
  }
)

export const initFonts = (theme) => {
  if (theme === 'landrover') {
    activateFontFace(FontLandroverBold, '--bold-font-face', 'Land Rover Bold')
    activateFontFace(FontAvenirRoman, '--regular-font-face', 'Avenir Roman')
    setProp('--accent-color', '#005A2B')
  }
  if (theme === 'jaguar') {
    activateFontFace(
      FontProximaNovaBold,
      '--bold-font-face',
      'Proxima Nova Bold'
    )
    activateFontFace(
      FontProximaNova,
      '--regular-font-face',
      'Proxima Nova Regular'
    )
    setProp('--accent-color', '#9E1B32')
  }
}
